import axios from 'axios';
import { createFolderQuery } from './queries';

const addFolder = (model) =>
    new Promise((resolve, reject) => {
        const query = createFolderQuery({ model });
        const request = axios.post(query.url, { ...query.body });
        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add folder'));
            });
    });

export default addFolder;
